import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Palette, TrendingUp, Sparkles } from 'lucide-react';
export function Revelation() {
  const features = [{
    icon: PenTool,
    title: 'Un Redactor',
    desc: 'Que escribe por ti'
  }, {
    icon: Palette,
    title: 'Un Diseñador',
    desc: 'Que crea portadas hermosas'
  }, {
    icon: TrendingUp,
    title: 'Un Vendedor',
    desc: 'Que cierra ventas 24/7'
  }];
  return <section className="bg-light py-12 md:py-24 px-4" data-id="element-239">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-240">
        <div className="text-center mb-12" data-id="element-241">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-4" data-id="element-242">
            <Sparkles className="w-8 h-8 text-primary" data-id="element-243" />
          </div>
          <span className="block text-primary font-bold uppercase tracking-wider text-sm mb-2" data-id="element-244">
            La Revelación
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-245">
            Tu Socio Silencioso
          </h2>
        </div>

        <div className="text-lg md:text-xl text-body leading-relaxed text-center max-w-3xl mx-auto mb-12" data-id="element-246">
          <p className="mb-6" data-id="element-247">
            Hoy, la{' '}
            <strong className="text-dark" data-id="element-248">Inteligencia Artificial (IA)</strong>{' '}
            es el socio silencioso que todas las mamás exitosas están usando.
          </p>
          <p data-id="element-249">
            Imagina tener a un equipo completo trabajando para ti las 24 horas,
            gratis, dentro de tu celular:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-250">
          {features.map((feat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white rounded-[20px] border border-border p-8 hover:shadow-xl transition-shadow text-center" data-id="element-251">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4 text-primary" data-id="element-252">
                <feat.icon className="w-8 h-8" data-id="element-253" />
              </div>
              <h3 className="text-xl text-dark font-display font-bold mb-2" data-id="element-254">
                {feat.title}
              </h3>
              <p className="text-body leading-relaxed" data-id="element-255">{feat.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark text-white rounded-[20px] p-8 md:p-10 text-center shadow-xl" data-id="element-256">
          <p className="text-xl md:text-2xl font-medium" data-id="element-257">
            No necesitas aprender IA, solo necesitas aprender a dirigirla.{' '}
            <br data-id="element-258" />
            <strong className="text-primary mt-2 block" data-id="element-259">
              Eso es lo que hace el "Sistema Mamá IA" por ti.
            </strong>
          </p>
        </div>
      </motion.div>
    </section>;
}